'use strict';

var isNode = typeof document === 'undefined';
if (!isNode) {
    // Avenir, from fonts.com:
    require('./fonts.scss');
    // Reso, from myfonts.com (path on STATIC_HOST or platforms/static/htdocs):
    _load_MyFonts(`/static/fonts/reso/`,'reso');
    _load_MyFonts('/static/fonts/avenir','avenir');
    _load_MyFonts('/static/fonts/avenir','avenir', 'woff2');
}

/* This is a slightly altered version of the MyFonts font loader:
 *     - comment out the MyFonts 3rd-party tracking code
 *     - wrap the whole thing in isNode (parent scope)
 *     - change customPath (now passed as parameter)
 */

function _load_MyFonts(customPath,fontName,type=null) {
    /*

     MyFonts Webfont Build ID 3231631, 2016-06-10T20:54:29-0400

     The fonts listed in this notice are subject to the End User License
     Agreement(s) entered into by the website owner. All other parties are 
     explicitly restricted from using the Licensed Webfonts(s).

     You may obtain a valid license at the URLs below.

     Webfont: Reso by JCFonts
     URL: http://www.myfonts.com/fonts/jcfonts/reso/regular/

     Webfont: ResoBold by JCFonts
     URL: http://www.myfonts.com/fonts/jcfonts/reso/bold/

     Webfont: ResoLight by JCFonts
     URL: http://www.myfonts.com/fonts/jcfonts/reso/light/

     Webfont: ResoThin by JCFonts
     URL: http://www.myfonts.com/fonts/jcfonts/reso/thin/

     Webfont: ResoSemiBold by JCFonts
     URL: http://www.myfonts.com/fonts/jcfonts/reso/semi-bold/


     License: http://www.myfonts.com/viewlicense?type=web&buildid=3231631
     Licensed pageviews: 100,000
     Webfonts copyright: Copyright (c) 2013 by Joel Carrouche. All rights reserved.

     ? 2016 MyFonts Inc
    */


    /* Commented out MyFonts analytics:
    var protocol = document.location.protocol;
    "https:" != protocol && (protocol = "http:");
    var count = document.createElement("script");
    count.type = "text/javascript";
    count.async = !0;
    count.src = protocol + "//hello.myfonts.net/count/314f8f";
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(count, s); */

    var browserName, browserVersion, webfontType;
    if ("undefined" == typeof woffEnabled) var woffEnabled = !0;
    var svgEnabled = 0,
        woff2Enabled = 1;
    if ("undefined" != typeof customPath) var path = customPath;
    else {
        var scripts = document.getElementsByTagName("SCRIPT"),
            script = scripts[scripts.length - 1].src;
        script.match("://") || "/" == script.charAt(0) || (script = "./" + script);
        path = script.replace(/\\/g, "/").replace(/\/[^\/]*\/?$/, "")
    }
    console.log()
    var wfpath = path,
        browsers = [{
            regex: "MSIE (\\d+\\.\\d+)",
            versionRegex: "new Number(RegExp.$1)",
            type: [{
                version: 9,
                type: "woff"
            }, {
                version: 5,
                type: "eot"
            }]
        }, {
            regex: "Trident/(\\d+\\.\\d+); (.+)?rv:(\\d+\\.\\d+)",
            versionRegex: "new Number(RegExp.$3)",
            type: [{
                version: 11,
                type: "woff"
            }]
        }, {
            regex: "Firefox[/s](\\d+\\.\\d+)",
            versionRegex: "new Number(RegExp.$1)",
            type: [{
                version: 3.6,
                type: "woff"
            }, {
                version: 3.5,
                type: "ttf"
            }]
        }, {
            regex: "Edge/(\\d+\\.\\d+)",
            versionRegex: "new Number(RegExp.$1)",
            type: [{
                version: 12,
                type: "woff"
            }]
        }, {
            regex: "Chrome/(\\d+\\.\\d+)",
            versionRegex: "new Number(RegExp.$1)",
            type: [{
                version: 36,
                type: "woff2"
            }, {
                version: 6,
                type: "woff"
            }, {
                version: 4,
                type: "ttf"
            }]
        }, {
            regex: "Mozilla.*Android (\\d+\\.\\d+).*AppleWebKit.*Safari",
            versionRegex: "new Number(RegExp.$1)",
            type: [{
                version: 4.1,
                type: "woff"
            }, {
                version: 3.1,
                type: "svg#wf"
            }, {
                version: 2.2,
                type: "ttf"
            }]
        }, {
            regex: "Mozilla.*(iPhone|iPad).* OS (\\d+)_(\\d+).* AppleWebKit.*Safari",
            versionRegex: "new Number(RegExp.$2) + (new Number(RegExp.$3) / 10)",
            unhinted: !0,
            type: [{
                version: 5,
                type: "woff"
            }, {
                version: 4.2,
                type: "ttf"
            }, {
                version: 1,
                type: "svg#wf"
            }]
        }, {
            regex: "Mozilla.*(iPhone|iPad|BlackBerry).*AppleWebKit.*Safari",
            versionRegex: "1.0",
            type: [{
                version: 1,
                type: "svg#wf"
            }]
        }, {
            regex: "Version/(\\d+\\.\\d+)(\\.\\d+)? Safari/(\\d+\\.\\d+)",
            versionRegex: "new Number(RegExp.$1)",
            type: [{
                version: 5.1,
                type: "woff"
            }, {
                version: 3.1,
                type: "ttf"
            }]
        }, {
            regex: "Opera/(\\d+\\.\\d+)(.+)Version/(\\d+\\.\\d+)(\\.\\d+)?",
            versionRegex: "new Number(RegExp.$3)",
            type: [{
                version: 24,
                type: "woff2"
            }, {
                version: 11.1,
                type: "woff"
            }, {
                version: 10.1,
                type: "ttf"
            }]
        }],
        browLen = browsers.length,
        suffix = "",
        i = 0;
    a: for (; i < browLen; i++) {
        var regex = new RegExp(browsers[i].regex);
        if (regex.test(navigator.userAgent)) {
            browserVersion = eval(browsers[i].versionRegex);
            var typeLen = browsers[i].type.length;
            for (var j = 0; j < typeLen; j++)
                if (browserVersion >= browsers[i].type[j].version && (1 == browsers[i].unhinted && (suffix = "_unhinted"), webfontType = browsers[i].type[j].type, "woff" != webfontType || woffEnabled) && ("woff2" != webfontType || woff2Enabled) && ("svg#wf" != webfontType || svgEnabled)) break a
        } else webfontType = "woff"
    }
    /(Macintosh|Android)/.test(navigator.userAgent) && "svg#wf" != webfontType && (suffix = "_unhinted");
    var head = document.getElementsByTagName("head")[0],
        stylesheet = document.createElement("style");
    stylesheet.setAttribute("type", "text/css");
    head.appendChild(stylesheet);
    
    var fonts = [];
    var avenirUrls = {
        "Avenir Next Cyr W00 Thin":{
            eot:"/65f66e6b-d28d-4c94-b661-66511860c2c7.eot",
            woff2:"/0b79d335-83f4-416a-b9b7-0e81d6258db7.woff2",
            woff:"/ab86f3dc-10a7-4bf1-bab8-e84f506f6d45.woff",
            ttf:"/e0f6c0c2-cd05-4327-acb3-5543c3d7feac.ttf",
            svg:"/0e59386d-0330-4e45-8bdd-026fc0e73d71.svg"
        },
        "Avenir Next Cyr W00 Regular":{
            eot:"/069faa0e-9913-48c4-9ef7-89a4bc080b65.eot",
            woff2:"/7db1f672-3a8f-4d19-9c49-7f61aed450b5.woff2",
            woff:"/4ab86b35-c0c2-42b5-98ad-4b6eba66b197.woff",
            ttf:"/276b3566-1c3b-4bc1-8915-15314f091f29.ttf",
            svg:"/5d02f5f4-46e7-453a-aef9-3e7106d7bb68.svg"
        }
    }
    switch(fontName){
        case 'reso':
            fonts.push({
                fontFamily: "Reso",
                url: wfpath + "314F8F_0" + suffix + "_0." + webfontType
            }, {
                fontFamily: "ResoBold",
                url: wfpath + "314F8F_1" + suffix + "_0." + webfontType
            }, {
                fontFamily: "ResoLight",
                url: wfpath + "314F8F_2" + suffix + "_0." + webfontType
            }, {
                fontFamily: "ResoThin",
                url: wfpath + "314F8F_3" + suffix + "_0." + webfontType
            }, {
                fontFamily: "ResoSemiBold",
                url: wfpath + "314F8F_4" + suffix + "_0." + webfontType
            })
            break;
        case 'avenir':
            fonts.push({
                fontFamily: "Avenir Next Cyr W00 Regular",
                url: wfpath + avenirUrls['Avenir Next Cyr W00 Regular'][type || webfontType]
            },{
                fontFamily: "Avenir Next Cyr W00 Thin",
                url: wfpath + avenirUrls['Avenir Next Cyr W00 Thin'][type || webfontType] 
            }
            )
            break;

    }
    var css = "";
    fonts.forEach(function(font){
        var format = type 
                     ? 'format("' + type + '")'
                     : "svg#wf" == webfontType
                     ? 'format("svg")' 
                     : "ttf" == webfontType 
                     ? 'format("truetype")' 
                     : "eot" == webfontType 
                     ? "" 
                     : 'format("' + webfontType + '")'

        css += ("@font-face{font-family: " + font.fontFamily + ";"+
                    "font-display:swap;src:url(" + font.url + ")" + format + ";");
        font.fontWeight && (css += "font-weight: " + font.fontWeight + ";");
        font.fontStyle && (css += "font-style: " + font.fontStyle + ";");
        css += "}"
    })
    stylesheet.styleSheet ? stylesheet.styleSheet.cssText = css : stylesheet.innerHTML = css;
}


// WEBPACK FOOTER //
// ./src/global/fonts.js